import { ServerMessagePayload } from '@common/api';

import { ClientRegistry } from '../components';
import {
  ClientFilteredComponentSystem,
  FilteredClientComponentSystemUpdateEntityArgs,
} from './ClientBase';

export class SpriteLifecycleSystem extends ClientFilteredComponentSystem {
  public componentClasses: (keyof ClientRegistry)[] = ['PixiSprite', 'MarkedForDestruction'];

  updateEntity({
    entityId,
  }: FilteredClientComponentSystemUpdateEntityArgs): ServerMessagePayload[] {
    const stage = this.clientServices.render.stage;
    const pixiInstanceService = this.clientServices.pixiInstance;

    // Clean up sprite
    const sprite = pixiInstanceService.deleteSprite(entityId);
    if (sprite && stage) {
      stage.removeChild(sprite);
      sprite.destroy();
    }

    // Clean up shadow
    const shadow = pixiInstanceService.deleteShadow(entityId);
    if (shadow && stage) {
      stage.removeChild(shadow);
      shadow.destroy();
    }

    return [];
  }
}
